module.exports = __webpack_public_path__ + "img/1390616261.0654fd72.jpg";